import { render, staticRenderFns } from "./HasReceptionDesk.vue?vue&type=template&id=41f3919c&"
import script from "./HasReceptionDesk.vue?vue&type=script&lang=ts&"
export * from "./HasReceptionDesk.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports